import { api, ApiRequestConfig } from './api';
import { FetchModelProps, ModelJson } from '../types/model';

export const GET_MODEL_URL = 'getModel';

export const getModel = (params: FetchModelProps, config: ApiRequestConfig) =>
  api.get<ModelJson>(GET_MODEL_URL, params, config);
